import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedChargebacksRecommendationData } from "mappers";
import { chargebacksDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetChargebackRecommendationQueryProps = {
	chargebackId: string;
};

const useGetChargebackRecommendationQuery = ({
	chargebackId,
}: useGetChargebackRecommendationQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["chargebackRecommendationInfo", chargebackId],
		() =>
			chargebacksDetailsService.getRecommendationInfo({
				chargebackId,
			}),
		{
			select: data => {
				return getMappedChargebacksRecommendationData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!chargebackId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetChargebackRecommendationQuery;
